import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'next-themes';
import { useState, type ReactNode } from 'react';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/features/auth/auth-provider';
import { createQueryClient } from '@/lib/query-client';

export function Providers({ children }: { children: ReactNode }) {
  // Uma instância por montagem da aplicação, criada dentro do componente: cliente em
  // módulo compartilharia cache entre testes.
  const [queryClient] = useState(createQueryClient);

  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      <QueryClientProvider client={queryClient}>
        {/* Dentro do QueryClientProvider: a troca de empresa e o logout limpam o cache. */}
        <AuthProvider>{children}</AuthProvider>
        {/* Fora do AuthProvider: um aviso precisa aparecer mesmo com a árvore
            autenticada já desmontada. */}
        <Toaster />
      </QueryClientProvider>
    </ThemeProvider>
  );
}
